import { render } from "./SkinItem.vue?vue&type=template&id=1af38be2"
import script from "./SkinItem.vue?vue&type=script&lang=js"
export * from "./SkinItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__